var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}warn-24`,"viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"base",attrs:{"cx":"12","cy":"12","r":"12"}}),_c('circle',{staticClass:"sign",attrs:{"r":"3","transform":"matrix(1 0 0 -1 12 12)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }